import { ConnectedDebitReport } from 'widgets/report/debit';

export function DebitReportPage() {
  return <ConnectedDebitReport />;
}
